import Loading from '../../../Common/Loading';
import { GarbageDestination } from './GarbageDestination';
import { HasBathroom } from './HasBathroom';
import { HasPipedWater } from './HasPipedWater';
import { SanitaryDrainage } from './SanitaryDrainage';
import { WaterSupplier } from './WaterSupplier';
import { useBasicSanitationChartsDataContext } from './hooks/useBasicSanitationChartsDataContext';

export const Charts = () => {
    const { isLoading } = useBasicSanitationChartsDataContext();

    if (isLoading ) {
        return <Loading />;
    }

    return (
        <>
            <div className="charts-side-by-side-dashboards">
                <HasPipedWater />
                <HasBathroom />
            </div>
            <div className="charts-side-by-side-dashboards">
                <WaterSupplier />
                <SanitaryDrainage />
            </div>
            <div className="charts-row-dashboards">
                <GarbageDestination />
            </div>
        </>
    );
};
